import {
  ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation
} from '@angular/core';

import { IconSizeEnum, IWarranty, SdIconComponent } from '@seb/web-design-system/core';

import { SdWarrantyCheckboxComponent } from '../warranty-checkbox/warranty-checkbox.component';

@Component({
  selector: 'sd-warranty-checkbox-group',
  templateUrl: './warranty-checkbox-group.component.html',
  styleUrls: ['./warranty-checkbox-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdWarrantyCheckboxComponent, SdIconComponent]
})
export class SdWarrantyCheckboxGroupComponent {
  showAll = false;
  iconSizeEnum = IconSizeEnum;

  @Input()
  warranties: IWarranty[];

  @Input()
  verticalLayout = false;

  @Input()
  showMore: string;

  @Input()
  showLess: string;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.verticalLayout ? 'is-vertical' : '']
      .filter(Boolean)
      .join(' ');
  }

  @Output()
  warrantyClicked = new EventEmitter<IWarranty>();

  showAllWarranty() {
    this.showAll = !this.showAll;
  }

  onWarrantyClicked(warranty) {
    const warrantyId = warranty.id;
    this.warranties.forEach((warranty) => {
      if (warranty.id !== warrantyId) {
        warranty.state = false;
      }
    });
    this.warrantyClicked.emit(warranty);
  }
}
